import ApiManager from "@/api/ApiManager";
import {
  SUPER_SETTINGS,
  SUPER_ENABLE,
  SUPER_SET_PAYMENT_METHOD,
  SUPER_REFRESH_PAYMENT_METHOD,
  SUPER_SET_AUTO_UPLOAD,
  SUPER_MEMBER_VERIFICATIONS,
  SUPER_VERIFY_MEMBERS,
  SUPER_DEADLINES,
  SUPER_UPLOADS,
  SUPER_UPLOAD_DETAIL,
  SUPER_UPLOAD,
  SUPER_CONFIRM_PAID,
  SUPER_CANCEL_UPLOAD,
  SUPER_PAY_NOW,
  SUPER_SWITCH_TO_MANUAL,
  SUPER_DOWNLOAD_PAYMENTS_FILE,
  SUPER_DOWNLOAD_FUND_RESPONSE,
} from "../actionsType.js";

// Paying super through OZEDI (features/super-payment-ozedi.md). Every action returns the API's
// response body; a failure rejects with its { detail } as the other modules do. The two downloads
// resolve with a Blob and use downloadFileSuper, which unwraps the error JSON a blob response carries.
const actions = {
  [SUPER_SETTINGS](context, companyId) {
    return ApiManager.get(`/api/Super/Settings?companyId=${companyId}`);
  },
  [SUPER_ENABLE](context, companyId) {
    return ApiManager.post(`/api/Super/Enable?companyId=${companyId}`, {});
  },
  [SUPER_SET_PAYMENT_METHOD](context, { companyId, method, paymentCycle, maxPaymentAmount }) {
    return ApiManager.post(`/api/Super/PaymentMethod?companyId=${companyId}`, { method, paymentCycle, maxPaymentAmount });
  },
  [SUPER_REFRESH_PAYMENT_METHOD](context, companyId) {
    return ApiManager.post(`/api/Super/RefreshPaymentMethod?companyId=${companyId}`, {});
  },
  [SUPER_SET_AUTO_UPLOAD](context, { companyId, enabled }) {
    return ApiManager.post(`/api/Super/AutoUpload?companyId=${companyId}&enabled=${enabled}`, {});
  },
  [SUPER_MEMBER_VERIFICATIONS](context, companyId) {
    return ApiManager.get(`/api/Super/MemberVerifications?companyId=${companyId}`);
  },
  [SUPER_VERIFY_MEMBERS](context, companyId) {
    return ApiManager.post(`/api/Super/VerifyMembers?companyId=${companyId}`, {});
  },
  [SUPER_DEADLINES](context, companyId) {
    return ApiManager.get(`/api/Super/Deadlines?companyId=${companyId}`);
  },
  [SUPER_UPLOADS](context, payrollId) {
    return ApiManager.get(`/api/Super/Uploads?payrollId=${payrollId}`);
  },
  [SUPER_UPLOAD_DETAIL](context, uploadId) {
    return ApiManager.get(`/api/Super/UploadDetail?uploadId=${uploadId}`);
  },
  [SUPER_UPLOAD](context, { payrollId, checkOnly }) {
    return ApiManager.post(`/api/Super/Upload?payrollId=${payrollId}&checkOnly=${!!checkOnly}`, {});
  },
  [SUPER_CONFIRM_PAID](context, uploadId) {
    return ApiManager.post(`/api/Super/ConfirmPaid?uploadId=${uploadId}`, {});
  },
  [SUPER_CANCEL_UPLOAD](context, uploadId) {
    return ApiManager.post(`/api/Super/Cancel?uploadId=${uploadId}`, {});
  },
  [SUPER_PAY_NOW](context, uploadId) {
    return ApiManager.post(`/api/Super/PayNow?uploadId=${uploadId}`, {});
  },
  [SUPER_SWITCH_TO_MANUAL](context, uploadId) {
    return ApiManager.post(`/api/Super/SwitchToManual?uploadId=${uploadId}`, {});
  },
  [SUPER_DOWNLOAD_PAYMENTS_FILE](context, uploadId) {
    return ApiManager.downloadFileSuper(`/api/Super/PaymentsFile?uploadId=${uploadId}`);
  },
  [SUPER_DOWNLOAD_FUND_RESPONSE](context, responseId) {
    return ApiManager.downloadFileSuper(`/api/Super/FundResponseFile?responseId=${responseId}`);
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
